import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableAutoselectFirstLocation',
  initialState: false,
  reducers: {
    setEnableAutoselectFirstLocation(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableAutoselectFirstLocation } = slice.actions;

export default slice.reducer;
